import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function useDiscover() {
  const [job, setJob] = useState(null);
  const navigate = useNavigate();

  const start = useCallback(async () => {
    try {
      const { data } = await api.post("/planets/discover");
      setJob(data);
    } catch (e) {
      toast.error(errMsg(e));
    }
  }, []);

  useEffect(() => {
    if (!job || job.status === "complete" || job.status === "failed") return;
    const t = setInterval(async () => {
      try {
        const { data } = await api.get(`/jobs/${job.id}`);
        setJob(data);
      } catch (e) { /* keep polling */ }
    }, 1500);
    return () => clearInterval(t);
  }, [job]);

  useEffect(() => {
    if (job?.status === "complete" && job.planet_id) {
      const id = job.planet_id;
      const t = setTimeout(() => {
        setJob(null);
        navigate(`/planet/${id}`, { state: { reveal: true } });
      }, 1100);
      return () => clearTimeout(t);
    }
  }, [job, navigate]);

  return { job, start, dismiss: () => setJob(null) };
}
